// extracted by mini-css-extract-plugin
export default {"forgotWrapper":"forgot-password-form_forgotWrapper__CzI0k","formWrapper":"forgot-password-form_formWrapper__xZR5W"};